/* eslint-disable */
import { useLazyQuery, useMutation } from "@apollo/client";
import { Box, Container, Grid, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DifficultyChart from "../components/Keyword-Reserch/DifficultyChart";
import GlobalVolume from "../components/Keyword-Reserch/GlobalVolume";
import KeywordIdea from "../components/Keyword-Reserch/KeywordIdea";
import KeywordOverview from "../components/Keyword-Reserch/KeywordOverview";
import SearchVolume from "../components/Keyword-Reserch/SearchVolume";
import { usePopup } from "../context/commonPop";
import { GET_CPC_QUERY, KEYWORD_TRENDING, SAVE_KEYWORD_FOR_RANKING } from "../gql/queries/keyPlaner";
import ProjectSelectBox from "../components/Keyword-Reserch/ProjectSelectBox";
import { GetScrapyData } from "../hooks/scrapyData";
import { getDomain } from "../utils/myUtills";
import KeywordIdeatable from "../components/Keyword-Reserch/KeywordIdeatable";
import CpcTable from "../components/Keyword-Reserch/CpcTable";
import KeywordTrendingTable from "../../src/components/Keyword-Reserch/KeywordTrendingTable";
import KeywordTrendingDateTable from "../../src/components/Keyword-Reserch/KeywordTrendingDateTable";
import GetStartHead from "../components/Keyword-Reserch/GetStartHead";
import ResearchIntro from "../components/Keyword-Reserch/ResearchIntro";
import KeywordTrands from "../components/Keyword-Reserch/KeywordTrands";
const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 64px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "80px",
  "& .KeywordIdeasMainHeading": {
    "& h2": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "24px",
      fontWeight: 700,
      lineHeight: "1",
    },
  },
}));
const obj = { keywords: null, loc_id: null, country_Code: null };

const loaderObj = {
  keyPlanner: true,
  cpc: true,
  monthlySearch: true,
  suggestedKeywords: true,
  questionKeywords: true,
  keywordTrending: true,
};
function KeyWordReserch() {
  const { handleOpen } = usePopup();
  const [queryObj, setQueryObj] = useState(obj);
  const [isLoading, setIsLoading] = useState(false);
  const [isKeywordLoading, setIsKeywordLoading] = useState(false);
  const [allFalse, setAllFalse] = useState(false);
  const [fetchRes, setFetchRes] = useState(false);
  const { scrapyData } = GetScrapyData();
  const navigate = useNavigate();
  const [selectedKeyword, setSelectedKeyword] = useState({
    selectedProject: "",
    selectedDomain: "",
    keywords: queryObj,
    selectedProjectId: "",
  });
  const [totalAvgMonthlySearches, setTotalAvgMonthlySearches] = useState({ getTotalValue: 0, arrPercentageValue: [], locationCountryArr: [], SearchDomain_cpc_low: 0 });
  const [errors, setErrors] = useState({ keywords: "", loc_id: "" });
  const [loadingObj, setLoadingObj] = useState(loaderObj);
  const [monthlyData, setMonthlyData] = useState([]);
  const [suggestedKeywordsData, setSuggestedKeywordsData] = useState([]);
  const [questionKeywordsData, setQuestionKeywordsData] = useState([]);
  const [plannerData, setPlannerData] = useState({ relatedKeywords: [], similarKeywords: [] });
  const [trendingData, setTrendingData] = useState(null);
  const [keywordTrending] = useLazyQuery(KEYWORD_TRENDING);
  const [keyPlanner] = useMutation(GET_CPC_QUERY);
  const [saveKeywordForRanking] = useMutation(SAVE_KEYWORD_FOR_RANKING);
  const userData = useSelector(state => state.reducer.userData);

  const handleChangeDrop = event => {
    const { name, value } = event.target;
    if (name === "keywords") {
      setQueryObj(prev => ({ ...prev, [name]: value }));
      setSelectedKeyword(prevState => ({
        ...prevState,
        keywords: value,
      }));
    } else if (name === "loc_id") {
      setQueryObj(prev => ({ ...prev, [name]: value?.Geo_ID || null, country_Code: value?.Country_Code || null }));
    }
  };

  const validateForm = () => {
    const newErrors = { keywords: "", loc_id: "" };
    if (!queryObj.keywords || queryObj.keywords.length === 0) {
      newErrors.keywords = "This field is required";
    }
    if (!queryObj.loc_id) {
      newErrors.loc_id = "This field is required";
    }
    setErrors(newErrors);
    return newErrors.keywords === "" && newErrors.loc_id === "";
  };
  const HandleClickCpcFunc = async () => {
    if (userData?.subscriptionCredits?.keywordResearch === 0) {
      handleOpen(true, "Hey there! You don’t have enough credits for keyword research right now. please purchase or upgrade your plan!");
      return;
    }
    setFetchRes(true);
    try {
      setIsLoading(true);
      if (!validateForm()) {
        setIsLoading(false);
        setFetchRes(false);
        return;
      }

      setLoadingObj(loaderObj);

      const results = await Promise.allSettled([
        keyPlanner({
          variables: { input: queryObj },
        }).then(({ data }) => {
          const res = data?.keyPlanner;
          if (res) {
            // CPC data
            const cpcData = res.cpcData;
            if (cpcData) {
              const locationCountryArr = [];
              const arrPercentageValue = [];
              let oneBlockCPCDeatils = null;
              const getTotalValue = cpcData?.global_searches;

              cpcData?.cpcKeywordDetails.forEach(item => {
                locationCountryArr.push(item.locationCountry);
                arrPercentageValue.push(item.avgPercentage);

                if (queryObj.country_Code === item.locationCountry && !oneBlockCPCDeatils) {
                  oneBlockCPCDeatils = item;
                }
              });

              setTotalAvgMonthlySearches({
                getTotalValue,
                arrPercentageValue,
                locationCountryArr,
                SearchDomain_cpc_low: oneBlockCPCDeatils?.cpc_low,
              });
              setFetchRes({
                cpcKeywordDetails: cpcData.cpcKeywordDetails,
                global_searches: cpcData.global_searches,
                keywordType: cpcData.keywordType,
                searchKeywords: res.searchKeywords,
                difficulty_score: res.difficulty_score,
              });
            }
            setLoadingObj(perState => ({ ...perState, cpc: false }));

            // Planner data (similar + related keywords)
            if (res.keywordPlannerData) {
              setPlannerData(res.keywordPlannerData);
            }
            setLoadingObj(perState => ({ ...perState, keyPlanner: false }));

            // Monthly searches
            if (res.monthlySearchesData) {
              setMonthlyData(res.monthlySearchesData);
            }
            setLoadingObj(perState => ({ ...perState, monthlySearch: false }));

            // Suggested keywords
            if (res.suggestionKeywords) {
              setSuggestedKeywordsData(res.suggestionKeywords);
            }
            setLoadingObj(perState => ({ ...perState, suggestedKeywords: false }));

            // Related questions
            if (res.questionsForKeywords) {
              setQuestionKeywordsData(res.questionsForKeywords);
            }
            setLoadingObj(perState => ({ ...perState, questionKeywords: false }));

            setSelectedKeyword(prevState => ({
              ...prevState,
              keywords: res.searchKeywords,
            }));
          }
        }),

        keywordTrending({
          variables: {
            input: queryObj,
          },
          onCompleted: data => {
            setTrendingData(data?.keywordTrending);
            setLoadingObj(perState => ({ ...perState, keywordTrending: false }));
          },
          onError: error => {
            console.error("Error fetching data:", error);
            setIsLoading(false);
          },
        }),
      ]);

      results.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(`Query ${index + 1} failed:`, result.reason);
          handleOpen(true, `Query ${index + 1} failed`);
        }
      });

      setIsLoading(false);
    } catch (error) {
      console.error("Unexpected error:", error);
      setIsLoading(false);
    }
  };

  const allKeywords = [...(plannerData?.similarKeywords || []), ...(plannerData?.relatedKeywords || [])];
  const handleBlogGenerator = () => {
    if (allKeywords.length < 1) {
      return;
    }
    const pathname = `/urlKeywords/selected-keywords?menu=headerKeywords`;
    const state = {
      selectedKeywords: allKeywords,
      projectId: selectedKeyword.selectedProjectId,
    };
    navigate(pathname, { state: state });
  };

  const handleKeywordSave = async () => {
    setIsKeywordLoading(true);
    const input = {
      projectName: selectedKeyword.selectedProject,
      projectDomain: getDomain(selectedKeyword.selectedDomain),
      projectId: selectedKeyword.selectedProjectId,
      keyword: { keyword: queryObj?.keywords || "lunch box", countryCode: queryObj?.country_Code, loc_id: queryObj?.loc_id },
    };
    saveKeywordForRanking({
      variables: { input },
      onCompleted: async ({ keywordsForRanking }) => {
        if (keywordsForRanking) {
          handleOpen(true, "Add keyword to your project in successfully");
        }
        setIsKeywordLoading(false);
      },
      onError: error => {
        console.error("Error saving data:", error);
        handleOpen(true, error.message);
        setIsKeywordLoading(false);
      },
    });
  };

  const handleProjectChange = event => {
    const projectId = event.target.value;
    const selectedProject = scrapyData.find(project => project.id === projectId);
    setSelectedKeyword(prevState => ({
      ...prevState,
      selectedProject: selectedProject.projectName,
      selectedDomain: selectedProject.website,
      keywords: queryObj,
      selectedProjectId: selectedProject.id,
    }));
  };
  useEffect(() => {
    if (scrapyData.length > 0) {
      const firstProject = scrapyData[0];
      setSelectedKeyword({
        selectedProject: firstProject.projectName,
        selectedDomain: firstProject.website,
        keywords: queryObj,
        selectedProjectId: firstProject.id,
      });
    }
  }, [scrapyData]);

  useEffect(() => {
    const allFalses = Object.values(loadingObj).every(value => value === false);
    if (allFalses) {
      setAllFalse(true);
    }
    window.scrollTo(0, 0);
  }, [loadingObj]);

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Box>
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12}>
                <KeywordOverview queryObj={queryObj} handleChangeDrop={handleChangeDrop} HandleClickFunc={HandleClickCpcFunc} isLoading={isLoading} errors={errors} />
              </Grid>
            </Grid>
          </Box>
          {fetchRes ? (
            <Box>
              <Grid container spacing={2} mt={0}>
                {allFalse && (
                  <Grid item xs={12}>
                    <ProjectSelectBox
                      scrapyData={scrapyData}
                      handleProjectChange={handleProjectChange}
                      selectedProjectId={selectedKeyword.selectedProjectId || ""}
                      handleBlogGenerator={handleBlogGenerator}
                      handleKeywordSave={handleKeywordSave}
                      disabled={allKeywords.length < 1}
                      isKeywordLoading={isKeywordLoading}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12} md={4}>
                  <DifficultyChart difficultyScore={fetchRes?.difficulty_score || 0} loading={loadingObj?.cpc} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <CpcTable label="CPC" fetchRes={fetchRes} loading={loadingObj?.cpc} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <GlobalVolume cpcData={fetchRes?.cpcKeywordDetails || []} totalAvgMonthlySearches={totalAvgMonthlySearches?.getTotalValue || 0} loading={loadingObj?.cpc} />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <Box className="KeywordIdeasMainHeading">
                    <Typography component="h2">Keyword Ideas</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <KeywordIdea
                    label="Similar Keywords"
                    keywordsArray={plannerData?.similarKeywords || []}
                    searchKeywords={fetchRes?.searchKeywords}
                    loading={loadingObj?.keyPlanner}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <KeywordIdea
                    label="Related Keywords"
                    keywordsArray={plannerData?.relatedKeywords || []}
                    searchKeywords={fetchRes?.searchKeywords}
                    loading={loadingObj?.keyPlanner}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <KeywordIdeatable
                    label="Suggestion Keywords"
                    header="SUGGESTIONS"
                    keywordsArray={suggestedKeywordsData || []}
                    searchKeywords={fetchRes?.searchKeywords}
                    loading={loadingObj?.suggestedKeywords}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <KeywordIdeatable
                    label="Question Keywords"
                    header="QUESTIONS"
                    keywordsArray={questionKeywordsData || []}
                    searchKeywords={fetchRes?.searchKeywords}
                    loading={loadingObj?.questionKeywords}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12} md={12}>
                  <SearchVolume label="Search Volume" monthlyData={monthlyData || []} searchKeywords={fetchRes?.searchKeywords} loading={loadingObj?.monthlySearch} />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12} md={6}>
                  <KeywordTrendingTable label="Keywords Region" keywordsArray={trendingData?.trendingByRegion || []} loading={loadingObj?.keywordTrending} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <KeywordTrendingDateTable label="Keywords Trending" keywordsArray={trendingData?.keywordTrendingData || []} loading={loadingObj?.keywordTrending} />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12} md={12}>
                  <KeywordTrands
                    label="Keywords Trends"
                    keywordTrand={trendingData?.keywordTrendingData || []}
                    searchKeywords={queryObj?.keywords}
                    loading={loadingObj?.keywordTrending}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <GetStartHead />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <ResearchIntro />
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default KeyWordReserch;
